export default {
  女装: "quần áo phụ nữ",
  男装: "của nam giới",
  手机和小工具: "Điện thoại di động và tiện ích",
  居家生活: "Cuộc sống gia đình",
  电脑及周边设备: "Máy tính và thiết bị ngoại vi",
  美容及个人护理: "Làm đẹp và chăm sóc cá nhân",
  家用电器: "thiết bị gia dụng",
  健康与保健: "sức khỏe và sự khỏe mạnh",
  食品和饮料: "thức ăn và đồ uống",
  玩具_儿童和婴儿: "đồ chơi, trẻ em và trẻ sơ sinh",
  童装时尚: "thời trang trẻ em",
  视频游戏: "trò chơi điện tử",
  运动与户外: "Thể thao và ngoài trời",
  爱好与书籍: "Sở thích và sách",
  相机和无人机: "Máy ảnh và máy bay không người lái",
  宠物食品及用品: "Thức ăn và vật dụng cho thú cưng",
  女士包袋: "túi xách phụ nữ",
  男士包袋: "túi xách nam",
  珠宝及配饰: "Đồ trang sức và phụ kiện",
  手表: "đồng hồ ",
  女鞋: "giày nữ",
  男装鞋: "giày nam",
  汽车: "xe hơi",
  我附近的ShopeePay: "ShopPay gần tôi",
  餐饮_旅行和服务: "Ăn uống, du lịch và dịch vụ",
  旅行及行李: "Du lịch và hành lý",
  各种各样的: "Các loại khác nhau",
  我是来买什么的: "Tôi đang tìm mua?",
  对不起_找不到_相关的商品:
    "Rất tiếc, không tìm thấy sản phẩm nào liên quan đến [{0}]",
  类别: "Loại",
  产品: "Sản phẩm",
  店铺: "Cửa hàng",
  首页: "Bảng điều khiển",
  限时秒杀: "Khuyến mại chớp nhoáng trong thời gian có hạn",
  博客: "Blog",
  所有品牌: "Tất cả các thương hiệu",
  所有类别: "Tất cả danh mục",
  我的购物车: "Giỏ hàng của tôi",
  发货信息: "Thông tin giao hàng",
  交货信息: "Thông tin giao hàng",
  付款: "Sự chi trả",
  确认: "Xác nhận",
  您的购物车是空的: "Giỏ hàng của bạn đang trống",
  价格: "Giá ",
  税: "Thuế",
  数量: "Số lượng",
  总计: "Tổng cộng",
  移除: "Di dời",
  返回商店: "Quay lại cửa hàng",
  继续发货: "Tiếp tục vận chuyển",
  筛选: "Lọc",
  价格范围: "Phạm vi giá",
  排序方式: "Sắp xếp theo",
  最新: "Cập nhật",
  最旧: "Lâu đời nhất",
  价格从低到高: "Giá từ thấp đến cao",
  价格从高到低: "Giá từ cao đến thấp",
  选择交货类型: "Chọn loại giao hàng",
  送货上门: "Vận chuyển",
  继续付款: "Tiếp tục thanh toán",
  任何其他信息: "Bất kỳ thông tin nào khác",
  或者: "Hoặc",
  您的钱包余额: "Số dư trong ví của bạn",
  余额不足: "Thiếu cân bằng",
  支付: "Chi trả",
  我同意: "Tôi đồng ý",
  条款和条件: "Các điều khoản và điều kiện",
  退货政策: "Chính sách hoàn trả",
  隐私政策: "Chính sách bảo mật",
  概括: "Khái quát hóa",
  项目: "Dự án",
  全部的: "Tất cả",
  小计: "Tổng phụ",
  总运费: "Tổng chi phí vận chuyển",
  有优惠码吗_在这里输入: "Có mã giảm giá không? nhập vào đây",
  申请: "Áp dụng",
  编辑: "Biên tập",
  删除: "Xóa bỏ",
  添加新地址: "Thêm địa chỉ mới",
  继续交货信息: "Tiếp tục thông tin giao hàng",
  选择一个地址: "Chọn một địa chỉ",
  购买历史: "Lịch sử mua hàng",
  下载: "Tải xuống",
  已发送退款请求: "Đã gửi yêu cầu hoàn tiền",
  对比: "Đối chiếu",
  对话: "Thông báo tin nhắn",
  我的钱包: "Ví của tôi",
  工单: "Trình tự công việc",
  管理个人资料: "Quản lý hồ sơ",
  登出: "Đăng xuất",
  重置对比列表: "Đặt lại danh sách so sánh",
  您的对比列表为空: "Danh sách so sánh của bạn trống",
  在您的购物车中: "Trong giỏ hàng của bạn",
  在您的愿望清单中: "Trong danh sách mong muốn của bạn",
  在您的预定列表中: "Trong danh sách đặt chỗ của bạn",
  下载您的产品: "Tải xuống sản phẩm của bạn",
  选项: "Tùy chọn",
  什么都没找到: "Không kết quả",
  特色产品: "Sản phẩm nổi bật",
  最畅销: "Sản phẩm bán chạy",
  前_名: "{0} hàng đầu",
  查看更多: "Xem thêm",
  查看所有类别: "Xem tất cả danh mục",
  十大品牌: "Mười thương hiệu hàng đầu",
  查看所有品牌: "Xem tất cả thương hiệu",
  登录: "Đăng nhập",
  手机号码: "Số điện thoại",
  密码: "Mật khẩu",
  密码长度为6到16个字符: "Độ dài mật khẩu là 6 đến 16 ký tự",
  验证码: "Mã xác nhận",
  登录中: "Đăng nhập",
  游客登录: "Đăng nhập của khách truy cập",
  注册您的商店: "Đăng ký cửa hàng của bạn",
  现在申请: "Áp dụng ngay bây giờ",
  成为商家: "Đăng ký cửa hàng",
  现在注册: "Đăng ký ngay bây giờ",
  登录成功: "Đã hạ cánh thành công",
  通知: "Thông báo",
  未找到通知: "Không tìm thấy thông báo",
  评论: "Bình luận",
  估计运输时间: "Thời gian vận chuyển ước tính",
  天: " ngày",
  所售: "Đã bán",
  给商家留言: "Để lại tin nhắn cho người bán",
  规格: "Sự chỉ rõ",
  库存: "Trong kho",
  总价: "Tổng giá",
  添加到购物车: "Thêm vào giỏ hàng",
  立即购买: "Mua nó ngay bây giờ",
  缺货: "Hết hàng",
  添加到愿望清单: "Thêm vào danh sách yêu thích",
  加入对比列表: "Thêm vào danh sách so sánh",
  退款: "Đền bù",
  查看条款: "Xem điều khoản",
  分享: "Chia sẻ",
  描述: "Mô tả",
  相关产品: "Những sảm phẩm tương tự",
  没有人问过商家: "Không ai hỏi các thương gia",
  该产品暂无评论: "Không có đánh giá cho sản phẩm này",
  客户评论: "Phản hồi khách hàng",
  访问商店: "Ghé thăm cửa hàng",
  畅销产品: "Bán chạy nhất",
  日期: "Ngày",
  订单编号: "Số thứ tự",
  总额: "Số tiền một lần",
  状态: "Tình trạng",
  愿望清单: "Danh sách yêu thích",
  还没有添加任何东西: "Chưa có gì được thêm vào",
  注册: "Đăng ký",
  邀请码: "Mã giới thiệu",
  请输入邀请码: "Vui lòng nhập mã mời",
  用户名: "Tên tài khoản",
  请输入用户名: "Vui lòng nhập tên người dùng",
  用户名长度为6_14个字符: "Độ dài tên người dùng là 6-14 ký tự",
  昵称: "Tên nick",
  请输入手机号码: "Vui lòng nhập số điện thoại",
  手机号码格式错误: "Định dạng sai số điện thoại",
  密码长度为6_16个字符: "Độ dài mật khẩu là 6-16 ký tự",
  确认密码: "Xác nhận mật khẩu",
  请输入确认密码: "Vui lòng nhập mật khẩu xác nhận",
  提款密码: "Mật khẩu rút tiền",
  请输入提款密码: "Vui lòng nhập mật khẩu rút tiền",
  提款密码长度为4_16个字符: "Độ dài mật khẩu rút tiền là 4-16 ký tự",
  请输入验证码: "Vui lòng nhập mã xác nhận",
  在_s后发送: "Đã gửi sau {0} giây",
  发送验证码: "Gửi mã xác minh",
  注册即表示您同意我们的条款和条件:
    "Bằng cách đăng ký, bạn đồng ý với các điều khoản và điều kiện của chúng tôi.",
  创建账号: "Tạo một tài khoản",
  验证码发送成功: "Mã xác minh đã được gửi thành công",
  确认密码不一致: "Xác nhận rằng mật khẩu không nhất quán",
  提款密码必须为数字: "Mật khẩu rút tiền phải là số",
  注册成功: "Đăng ký thành công",
  购物车: "Giỏ hàng",
  账户: "Tài khoản",
  我的账户: "Tài khoản của tôi",
  已经有一个账户: "Bạn co săn san để tạo một tai khoản",
  新地址: "Địa chỉ mới",
  编辑地址: "Sửa địa chỉ",
  保存: "Lưu",
  是否默认: "Đây có phải là mặc định không",
  具体地址: "Địa chỉ cụ thể",
  请输入具体地址: "Vui lòng nhập địa chỉ cụ thể",
  地区: "Khu vực",
  请输入地区: "Vui lòng nhập khu vực",
  城市: "Thành phố",
  请输入城市: "Vui lòng nhập thành phố",
  省份: "Tỉnh",
  请输入省份: "Vui lòng nhập tỉnh",
  邮政编码: "Mã bưu điện",
  请输入邮政编码: "Vui lòng nhập mã bưu chính",
  电话号码: "Số điện thoại",
  请输入电话号码: "Xin vui lòng điền số điện thoại của bạn",
  收货人: "Người nhận",
  请输入收货人: "Vui lòng nhập người nhận hàng",
  保存成功: "Đã lưu thành công",
  最畅销的商家: "Thương gia bán chạy nhất",
  查看所有的商家: "Xem tất cả doanh nghiệp",
  支持政策: "Chính sách hỗ trợ",
  您的电子邮件地址: "Địa chỉ email của bạn",
  订阅: "Đăng ký",
  联系方式: "Thông tin liên lạc",
  地址: "Địa chỉ",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, Hoa Kỳ",
  快速链接: "Đường dẫn nhanh",
  商家政策: "Chính sách của người bán",
  submit: "Nộp",
  提款银行卡: "Rút thẻ ngân hàng",
  我的面板: "Bảng điều khiển của tôi",
  提示: "Gợi ý",
  确定登出吗: "Bạn có chắc chắn bạn muốn thoát?",
  确定: "Chắc chắn",
  取消: "Hủy bỏ",
  项目添加到您的购物车: "Thêm mặt hàng vào giỏ hàng của bạn",
  经常一起购买: "Thường mua cùng nhau",
  返回购物: "Quay lại mua sắm",
  进行结算: "Tiến hành kiểm tra",
  帮助热线: "Đường dây trợ giúp",
  查看所有通知: "Xem tất cả thông báo",
  请输入密码: "Xin vui lòng nhập mật khẩu",
  前往充值: "Đi để nạp tiền",
  购物车物品: "Các mặt hàng trong giỏ hàng",
  查看购物车: "Kiểm tra giỏ hàng",
  钱包余额: "Số dư ví",
  充值钱包: "Nạp tiền vào ví",
  钱包充值_线下_: "Nạp tiền vào ví (ngoại tuyến)",
  申请提款: "Đăng ký rút tiền",
  钱包收支明细: "Chi tiết thu nhập và chi tiêu của ví",
  批准: "Chấp thuận",
  提现历史记录: "Lịch sử rút tiền",
  类型: "Kiểu",
  信息: "Thông tin",
  付款方式: "Phương thức thanh toán",
  请选择付款方式: "Vui lòng chọn phương thức thanh toán",
  Bill_Type_RECHARGE_BACK: "Nạp tiền phụ trợ",
  Bill_Type_RECHARGE_ONLINE: "Nạp tiền trực tuyến",
  Bill_Type_RECHARGE_REGISTER: "Đăng kí miễn phí",
  Bill_Type_RECHARGE_JACKPOT: "Tiền thưởng nạp tiền",
  Bill_Type_RECHARGE_PRESENT: "Nạp tiền thưởng",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Chuyển khoản hoa hồng",
  Bill_Type_RECHARGE_TG_COMMISSION: "Hoa hồng khuyến mãi nạp tiền",
  Bill_Type_REGISTER_TG_COMMISSION: "Hoa hồng khuyến mãi đăng ký",
  Bill_Type_WITHDRAW: "Rút",
  Bill_Type_WITHDRAW_REJECT: "Rút tiền bị từ chối",
  Bill_Type_DEDUCT_HANDLE: "Khấu trừ thủ công",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Chỉnh sửa nạp tiền",
  Bill_Type_MINING_PROFIT: "Thu nhập khai thác",
  Bill_Type_MINING_PROFIT_COMMISSION: "Hoa hồng xúc tiến thu nhập khai thác",
  Bill_Type_VIP_UPGRADE: "Nâng cấp VIP",
  Bill_Type_FINANCE_BUY: "Mua sản phẩm tài chính",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Hoàn trả cân bằng tài chính",
  Bill_Type_FINANCE_FEE: "Phí quản lý tài chính",
  Bill_Type_FINANCE_PROFIT: "Thu nhập quản lý tài chính",
  Bill_Type_FINANCE_BUY_COMMISSION: "Hoa hồng mua sản phẩm tài chính",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Hoa hồng thu nhập sản phẩm tài chính",
  Bill_Type_WHEEL_DRAW: "Xổ số bánh xe lớn",
  Bill_Type_BUY: "Mua hàng",
  Bill_Type_PAY_SHOP: "Trả tiền vận chuyển",
  Bill_Type_BUY_COMMISSION: "Hoa hồng cho các mặt hàng đã mua",
  Bill_Type_DEPOSIT: "Trả tiền đặt cọc",
  Bill_Type_STORE_BUY: "Mua hàng",
  Bill_Type_STORE_BUY_REFUND: "Hoàn tiền mua sản phẩm",
  Bill_Type: "Loại thay đổi tài khoản",
  Before_Money: "Số tiền trước đó",
  Deal_Money: "Số tiền thay đổi tài khoản",
  After_Money: "Số tiền sau",
  Bill_Time: "Thời gian thay đổi tài khoản",
  No_More_Data: "Không còn dữ liệu",
  Apply_Money: "Số tiền đăng ký",
  Apply_Time: "Thời gian nộp đơn",
  Withdraw_Info: "Phí xử lý: {fee}, điểm đến: {money}",
  提款订单状态_CHECKING: "Đang chờ xem xét",
  提款订单状态_TRANSFERRING: "Chuyển giao",
  提款订单状态_PASS: "Đã xác nhận",
  提款订单状态_REJECT: "Bị loại bỏ",
  暂无可用充值方式: "Chưa có phương thức nạp tiền nào",
  钱包收款码: "Mã thanh toán ví",
  钱包地址: "Địa chỉ ví",
  金额限制: "Giới hạn số tiền",
  复制: "Sao chép",
  付款凭证: "Chứng từ thanh toán",
  收款银行: "Ngân hàng thụ hưởng",
  收款人: "Người nhận thanh toán",
  收款账号: "Số tài khoản thanh toán",
  付款银行: "Ngân hàng thanh toán",
  付款人: "Người trả tiền",
  付款账号: "Tài khoản thanh toán",
  请输入付款银行: "Vui lòng nhập ngân hàng thanh toán",
  请输入付款人: "Vui lòng nhập người trả tiền",
  请输入付款账号: "Vui lòng nhập số tài khoản thanh toán",
  请上传付款凭证: "Vui lòng tải lên chứng từ thanh toán",
  充值金额: "Số tiền nạp",
  请输入充值金额: "Vui lòng nhập số tiền nạp",
  submitting: "Đang gửi...",
  Confirm: "Nộp",
  Commit_Success: "Gửi thành công",
  balanceType_BALANCE: "THĂNG BẰNG",
  balanceType_COMMISSION: "Nhiệm vụ",
  Balance: "Số dư tài khoản",
  Wash_Money: "Thêm khảm",
  请选择银行账户: "Vui lòng chọn tài khoản ngân hàng",
  卡号类型: "Loại số thẻ",
  提现金额: "Số tiền rút",
  提款金额: "Số tiền rút",
  不能为空: "Không thể trống",
  金额不正确: "Số tiền không đúng",
  please_input_withdraw_password: "Vui lòng nhập mật khẩu rút tiền",
  withdraw_password_format_error: "Mật khẩu rút tiền phải từ 4-16 ký tự",
  Fee: "Phí xử lý",
  实际到账: "Đến thực tế",
  交易币种: "Tiền tệ giao dịch",
  原始密码: "Mật khẩu gốc",
  confirm_password_error: "Mật khẩu nhập 2 lần không chính xác",
  save_success: "Đã lưu thành công",
  please_input: "Vui lòng nhập",
  old_password: "Mật khẩu cũ",
  new_password: "Mật khẩu mới",
  please_input_confirm_password: "Vui lòng xác nhận lại mật khẩu",
  没有找到符合条件的商品: "Không tìm thấy sản phẩm phù hợp",
  Search: "Tìm kiếm",
  全部: "Tất cả",
  EnumGoodsOrderState_USER_PAY: "Chờ giao hàng",
  EnumGoodsOrderState_SHOP_PAY: "Đang giao hàng",
  EnumGoodsOrderState_SUCCESS: "Hoàn thành",
  EnumGoodsOrderState_CANCEL: "Đã hủy",
  EnumGoodsOrderState_REFUND_SUCCESS: "Được hoàn lại tiền",
  订单号: "Số thứ tự",
  用户名称: "Tên tài khoản",
  收益: "Thu nhập",
  支付时间: "Thời gian thanh toán",
  配送时间: "Thời gian giao hàng",
  完成时间: "Thời gian hoàn thành",
  发货: "Tàu thủy",
  全选: "Chọn tất cả",
  物品已添加到愿望清单: "Mục được thêm vào danh sách mong muốn",
  物品已添加到比较列表: "Mục được thêm vào danh sách so sánh",
  购买成功提示: "Xin chúc mừng, giao dịch mua hàng của bạn đã thành công",
  订单列表: "Danh sách đặt hàng",
  商品名: "Tên sản phẩm",
  图片: "Hình ảnh",
  没有品牌: "Không có thương hiệu",
  基本信息: "Thông tin cơ bản",
  Account_Name: "Tên mở tài khoản",
  Bank_Account: "Tài khoản ngân hàng",
  Bank_Phone: "Dự trữ số điện thoại di động",
  IFSC: "Tài khoản IFSC",
  UPI: "Tài khoản UPI",
  PIX: "Tài khoản PIX",
  CPF: "Tài khoản CPF",
  GCASH: "Tài khoản GCASH",
  POWWI: "Tài khoản POWWI",
  身份证号: "Số ID",
  Edit: "Ôn lại",
  Delete: "Xóa bỏ",
  Add: "Mới",
  Forget_Withdraw_Password: "Quên mật khẩu rút tiền",
  Bank_Card_Info: "Thông tin thẻ ngân hàng",
  收款人地址: "Địa chỉ người nhận thanh toán",
  SWIFT: "NHANH",
  Bank_Branch: "Tên chi nhánh",
  分行代码: "Mã chi nhánh",
  银行地址: "Địa chỉ ngân hàng",
  Email: "E-mail",
  银行卡长度必须超过: "Chiều dài của thẻ ngân hàng phải vượt quá {length}",
  银行卡格式不正确: "Định dạng thẻ ngân hàng không chính xác",
  Do_you_confirm_delete: "Xác nhận xóa?",
  Please_Login_First: "Vui lòng đăng nhập trước",
  Bank_Name: "Tên ngân hàng",
  Please_add_bank_first:
    "Bạn chưa ràng buộc thẻ ngân hàng, vui lòng thêm thẻ trước",
  withdrawType: "Loại rút tiền",
  withdraw_money_limit:
    "Số tiền rút phải lớn hơn 0 và nhỏ hơn hoặc bằng {balance}",
  withdraw_times_limit:
    "Bạn đã rút {todayWithdrawNum} lần trong ngày hôm nay và phí xử lý {withdrawFee}% sẽ được tính sau {limitTimes} lần. Bạn có chắc chắn rút tiền không?",
  Copy_Success: "Đã sao chép thành công",
  商店首页: "Trang chủ cửa hàng",
  所有产品: "Tất cả sản phẩm",
  新到货产品: "Sản phẩm mới về",
  所有商家: "Tất cả người bán",
  请上传: "Vui lòng tải lên",
  请输入: "Vui lòng nhập",
  忘记密码: "Quên mật khẩu",
  记得我: "Nhớ tôi",
  共_件: "Tổng số {0} mặt hàng",
  取消订单: "Hủy đơn hàng",
  申请退款: "Yêu cầu hoàn lại",
  未知商家: "Người bán không xác định",
  到账: "Biên lai",
  提款订单状态: "Trạng thái lệnh rút tiền",
  前_名类别: "{0} danh mục hàng đầu",
  取消订单原因_不想要了: "Không muốn nó nữa",
  取消订单原因_商品错选_多选: "Chọn sai sản phẩm/chọn nhiều sản phẩm",
  取消订单原因_商品无货: "Sản phẩm đã hết hàng",
  取消订单原因_地址信息填写错误: "Thông tin địa chỉ điền sai",
  取消订单原因_商品降价: "Giảm giá sản phẩm",
  取消订单原因_价格高于其他平台: "Giá cao hơn các nền tảng khác",
  取消订单原因_没用_少用_错用优惠:
    "Không sử dụng/ít sử dụng/lạm dụng các khoản giảm giá",
  退款原因_拍错_多拍_不喜欢: "Cú sút sai/cú đánh thừa/không thích",
  退款原因_商品成分描述不符: "Mô tả thành phần sản phẩm không khớp",
  退款原因_与商家协商一致退款: "Hoàn tiền theo thỏa thuận với người bán",
  退款原因_生产日期_保质期与商品描述不符:
    "Ngày sản xuất/hạn sử dụng không đúng với mô tả sản phẩm",
  退款原因_图片_产地_批号_规格等描述不符:
    "Hình ảnh/nguồn gốc xuất xứ/số lô/thông số kỹ thuật và các mô tả khác không khớp",
  退款原因_质量问题: "Những vấn đề về chất lượng",
  退款原因_商品变质_发霉_有异物: "Sản phẩm bị hư/mốc/có tạp chất",
  退款原因_少件_含缺少配件_: "Vài mảnh (bao gồm cả các phụ kiện còn thiếu)",
  退款原因_收到商品时有破损_污渍_变形:
    "Sản phẩm bị hư hỏng/bị ố/biến dạng khi nhận được.",
  退款原因_假冒品牌: "Thương hiệu giả",
  退款原因_发票问题: "Vấn đề về hóa đơn",
  退款原因_商家发错货: "Người bán đã gửi sai hàng",
  退款原因_预约不到_商家不给退换:
    "Không thể đặt lịch hẹn/người bán sẽ không hoàn lại tiền hoặc đổi hàng cho bạn",
  退款失败: "Hoàn tiền không thành công",
  退款处理中: "Đang hoàn tiền",
  默认: "Mặc định",
  产品查询: "Tìm kiếm sản phẩm",
  商店LOGO: "LOGO cửa hàng",
  推广码: "Mã giới thiệu",
  查看所有: "Xem tất cả",
  确认收货成功: "Xác nhận đã nhận hàng thành công",
  物流公司: "Công ty hậu cần",
  物流单号: "Số lô hàng",
  发货时间: "Thời gian vận chuyển",
  请先选择商品规格: "Vui lòng chọn thông số kỹ thuật sản phẩm trước",
  个人信息: "Thông tin cá nhân",
  您的用户名: "Tên người dùng của bạn",
  你的名字: "Tên của bạn",
  登录名: "Tên tài khoản",
  你的邮件: "Email của bạn",
  你的密码: "Mật khẩu của bạn",
  重复输入密码: "Lặp lại mật khẩu",
  店铺名称: "Tên cửa hàng",
  证书类型: "Loại chứng chỉ",
  身份证: "CMND",
  护照: "Hộ chiếu",
  驾驶执照: "Bằng lái xe",
  社会保障卡: "Thẻ an sinh xã hội",
  证书正面: "Mặt trước chứng chỉ",
  证书反面: "Mặt sau của chứng chỉ",
  确认收货: "Xác nhận đã nhận hàng",
  请选择取消订单的原因必选: "Vui lòng chọn lý do hủy đơn hàng (bắt buộc):",
  请选择申请退款的原因必选: "Vui lòng chọn lý do yêu cầu hoàn tiền (bắt buộc):",
  留言: "Tin nhắn",
  请输入留言: "Vui lòng nhập tin nhắn",
  没有帐户: "Không tài khoản",
  钱包充值: "Nạp tiền vào ví",
  输入您的文字: "Nhập văn bản của bạn",
  商家登录: "Đăng nhập cửa hàng",
  有关此产品的任何查询: "Mọi thắc mắc về sản phẩm này",
  产品名称: "Tên sản phẩm",
  你的问题: "Vấn đề của bạn",
  白银店铺: "Cửa hàng bạc",
  铂金店铺: "Cửa hàng bạch kim",
  钻石店铺: "Cửa hàng kim cương",
  照片: "Hình chụp",
  已退货: "Trả lại",
  邮寄状态: "Trạng thái gửi thư",
  订单摘要: "Tóm tắt theo thứ tự",
  收件地址: "Địa chỉ người nhận",
  订购日期: "Ngày đặt hàng",
  订单状态: "Tình trạng đặt hàng",
  总订单金额: "Tổng số tiền đặt hàng",
  邮寄方式: "Phương thức gửi thư",
  附加信息: "Thông tin thêm",
  订单详细信息: "Chi tiết đặt hàng",
  交货类型: "Loại giao hàng",
  进行评论: "Làm cho một bình luận",
  已评论: "Đã bình luận",
  订单金额: "Số lượng đơn đặt hàng",
  优惠券: "Phiếu mua hàng",
  统一运费: "Phí vận chuyển cố định",
  送货地址: "Địa chỉ giao hàng",
  评分: "Đánh giá sao",
  你的意见: "Ý kiến ​​của bạn",
  匿名: "Vô danh",
  现金: "Tiền mặt",
  详情: "Chi tiết",
  收货地址: "Địa chỉ giao hàng",
  暂时没有对话: "Chưa có cuộc trò chuyện nào",
  你: "Bạn",
  输入您的回复: "Nhập câu trả lời của bạn",
  删除成功: "Đã xóa thành công",
  品牌: "Thương hiệu",
  已缴纳的保证金: "Đã nộp tiền đặt cọc",
  黄金店铺: "Cửa hàng vàng",
  没有更多数据: "Không còn dữ liệu",
  站内信: "Thông báo trang web",
  系统通知: "Thông báo hệ thống",
  邮箱: "Thư",
  手机号: "Số điện thoại",
  你的手机号: "Số điện thoại của bạn",
  营业执照: "Giấy phép kinh doanh",
  你的邮箱: "Hộp thư của bạn",
  系统公告: "Thông báo hệ thống",
  客服: "dịch vụ khách hàng",
  消息已撤回: "Tin nhắn đã được rút lại",
  物流详情: "Chi tiết hậu cần",
  充值: "nạp tiền",
  提现: "rút",
  信用分: "điểm tín dụng",
  余额: "THĂNG BẰNG",
  佣金: "nhiệm vụ",
  继续购物: "tiếp tục mua sắm",
  订单结算: "Giải quyết đơn hàng",
  加入对比: "Thêm vào so sánh",
  佣金余额: "Số dư hoa hồng",
  刷新: "làm cho khỏe lại",
  刷新成功: "Làm mới thành công",
  官网: "Trang web chính thức",
  税号: "Mã số thuế",
  订单: "Đặt hàng",
  合计: "tổng cộng",
  系统安全: "Bảo mật hệ thống",
  Recharge_Money_Limit: "Số tiền nạp phải nằm trong khoảng từ {min} đến {max}",
  限时优惠: "Ưu đãi trong thời gian có hạn",
  高价回收: "Tái chế giá cao",
  姓名: "Tên",
  商品订单号: "Số đơn đặt hàng sản phẩm",
  商品在线回收: "Tái chế sản phẩm trực tuyến",
  提交: "nộp",
  回收记录: "Hồ sơ tái chế",
  回收状态: "Tình trạng tái chế",
  回收价格: "giá tái chế",
  纳税码: "mã số thuế",
  买家登录: "Đăng nhập",
  买家注册: "đăng ký",
  语言: "越南语",
  搜索结果: "Kết quả tìm kiếm",
  language: "Trung Quốc",
  助力提示:
    "Giúp các thương nhân có thể tăng mức độ tiếp xúc của nền tảng với các cửa hàng của họ và số ngày tích lũy càng cao thì mức độ phơi nhiễm càng cao.",
  已累计助力: "Hỗ trợ tích lũy",
  今日已助力: "Hôm nay đã giúp",
  立即助力: "Giúp đỡ ngay lập tức",
  商家助力: "Giúp đỡ thương gia",
  证件号码: "Số ID",
  证书号码: "Số chứng chỉ"
};
